import { Suspense } from "react";
import dynamic from "next/dynamic";
import useQuery from "../../hooks/useQuery";
import { ListingPageProps } from "../../types/ListingPage.interface";
import { useRouter } from "next/router";
const NotListing = dynamic(
  () => import("../../components/Listing/NotListing"),
  {
    suspense: true,
  }
);

const Card = dynamic(() => import("../../components/Card"), {
  suspense: true,
});

const Pagination = dynamic(() => import("rc-pagination"), { suspense: true });
const NeighbourhoodList = dynamic(
  () => import("../../components/Listing/Neighbourhood"),
  { suspense: true }
);

const Desktop: React.FC<ListingPageProps> = ({
  query,
  community,
  city,
  properties,
  neighbourhoods,
}) => {
  const queries = useQuery(query);
  const router = useRouter();
  return (
    <div className="flex container mx-auto">
      <div className="flex flex-col lg:flex-row justify-between relative flex-1">
        <div
          style={{ width: "100%" }}
          className="overflow-hidden flex-1 2xl:flex-none 2xl:w-[40%]"
        >
          <div>
            <div className="flex md:justify-between justify-center flex-wrap items-center">
              <div className="px-2 py-3 flex justify-center md:justify-between items-center flex-wrap">
                <h1 className="font-medium line-clamp-1 text-xl">
                  Bungalows for sale in{" "}
                  {router.query.community ? community?.label : city.label}
                  {"  Ontario"}
                </h1>
                <p className="font-medium text-xl">
                  , {properties.total} Listings
                </p>
              </div>
            </div>
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              {properties.property.length !== 0 ? (
                <div
                  className={`px-2 py-1 grid overflow-hidden grid-cols-1 md:grid-cols-2  gap-2 xl:grid-cols-4 `}
                >
                  {properties.property.map((property, index) => (
                    <Card key={index} property={property} />
                  ))}
                </div>
              ) : (
                <>
                  <Suspense
                    fallback={
                      <>
                        <p>Loading...</p>
                      </>
                    }
                  >
                    <NotListing />
                  </Suspense>
                </>
              )}
            </Suspense>
            <div className="px-2 py-5 text-center">
              <Suspense
                fallback={
                  <>
                    <p>Loading...</p>
                  </>
                }
              >
                <Pagination
                  total={properties.total}
                  pageSize={12}
                  defaultCurrent={query.page}
                  onChange={(page) => {
                    queries.push({
                      page,
                    });
                  }}
                />
              </Suspense>
            </div>
          </div>
          <hr />
          <div className="flex flex-wrap">
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              {neighbourhoods && neighbourhoods.length > 0 && (
                <NeighbourhoodList neighbourhoods={neighbourhoods || []} />
              )}
            </Suspense>
          </div>
          <hr />
          <div>
            <div
              className="px-2 py-5 element"
              dangerouslySetInnerHTML={{
                __html:
                  router.query.community && community?.content
                    ? community.content
                    : city.content
                    ? city.content
                    : "",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Desktop;

